import React from "react";
import { ChevronDown } from "lucide-react";

export const MobileStepSelect = ({ id, label, value, options, onChange }) => <div className="mobile-step-select" data-update-safe="true" data-testid={`${id}-control`}>
  <label htmlFor={`${id}-select`} data-testid={`${id}-label`}>{label}</label>
  <div><select id={`${id}-select`} value={value} onChange={event => onChange(event.target.value)} data-testid={`${id}-select`}>{options.map(option => <option key={option.value} value={option.value}>{option.label}</option>)}</select><ChevronDown size={18} aria-hidden="true" /></div>
</div>;